import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material';

interface DeclarationModalProps {
    open: boolean;
    onClose: () => void;
    onAccept: () => void;
    textInfo: string;
}

export const DeclarationModal: React.FC<DeclarationModalProps> = ({
    open,
    onClose,
    onAccept,
    textInfo,
}) => {
    const contentRef = useRef<HTMLDivElement>(null);
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            {/* <DialogTitle>Декларация о состоянии здоровья</DialogTitle> */}
            <DialogContent dividers sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Box
                    ref={contentRef}
                    sx={{
                        maxHeight: '60vh',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#ccc',
                            borderRadius: '4px',
                        },
                    }}
                >
                    <Box
                        dangerouslySetInnerHTML={{ __html: textInfo || '<p>Текст декларации отсутствует.</p>' }}
                        sx={{ paddingBottom: '20px' }}
                    />
                    <Box
                        id="accept-button"
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            padding: '16px',
                            backgroundColor: '#f5f5f5',
                            borderTop: '1px solid #ddd',
                        }}
                    >
                        <Button
                            onClick={() => {
                                onAccept();
                                onClose();
                            }}
                            variant="contained"
                            sx={{ backgroundColor: '#0054E6', }}

                        >
                            Принять
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};